import { RouteMetadata } from './types';

export const secretsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/secrets',
        section: 'secrets',
        view: 'list',
        descriptionTemplate: 'User is viewing the secrets list',
        capabilities: [
            'View all secrets (values are hidden)',
            'Create new secrets',
            'Update secret values',
            'Update secret descriptions',
            'Delete unused secrets',
            'See which workflows and tools reference each secret',
        ],
        hints: [
            'Secrets store sensitive values like API keys and passwords',
            'Secret values are encrypted and never exposed in the UI',
            'Secrets can be referenced in workflows using {{secrets.KEY_NAME}}',
            'Deleting a secret used by a workflow will cause runtime errors',
            'Secrets show reference counts to prevent accidental deletion',
        ],
    },
];
